export const imageGalleryInstructions = 'Hover over image to zoom in';
export const hoveredmageGalleryInstructions =
    'Click image to open expanded view';
